var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcasePortfolio1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10l-1.74846e-07-3.55271e-15c-2.20914-9.65645e-08-4-1.79086-4-4 0 0 0 0 0 0v-8l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h14l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v8l3.55271e-15 8.74228e-08c0 2.20914-1.79086 4-4 4 -5.41844e-08 0-3.32383e-08 0-8.74228e-08 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v-2l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h4l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    x: 10,
    y: 11,
    rx: 0.27614,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5h3.5l-1.5299e-07-3.55271e-15c1.933 8.4494e-08 3.5-1.567 3.5-3.5v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5h-3.5l-1.5299e-07-3.55271e-15c-1.933-8.4494e-08-3.5-1.567-3.5-3.5 0 0 0-1.77636e-15 0-1.77636e-15h-3.55271e-15"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24h-24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcasePortfolio1);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/suitcase-portfolio-1.3dd98fb291ddd62129bac239d62a717c.svg";
export { MemoForwardRef as ReactComponent };